// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c7b38cf","453":"d41f61e7","455":"177afd88","977":"ae942c76"}[chunkId] + ".chunk.js";
};